import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import DataGridComponent from "@molecules/data-grid/data-grid.component";
import FeatherIcon from "feather-icons-react";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import ModulesSwapContentComponent from "./components/modules-swap-content.component";

const ActionContent = ({ handleCreateClick }) => {
  return (
    <button
      type="button"
      className="btn btn-primary btn-sm"
      onClick={handleCreateClick}
    >
      <FeatherIcon icon="plus" size={17} />
    </button>
  );
};

function ModulesListTemplateComponent({
  templateModal: {
    tableTitle,
    keyColumn,
    breadCrumbs,
    tableColumn,
    tableData,
    totalCount,
    filters,
    tableConfig,
    tableControls,
    swapContentType,
  },
  templateEvents: {
    getModulesData,
    handleCreateClick,
    deleteRecords,
    handleInlineEditSave,
    submitFilter,
  },
}) {
  const settingFormEdit = `${breadCrumbs[1].menu_url}/edit`;

  return (
    <PageWrapperComponent>
      <PageHeadComponent
        title={"All Modules"}
        breadCrumbs={breadCrumbs}
        actionContent={<ActionContent handleCreateClick={handleCreateClick} />}
      />
      <DataGridComponent
        title={tableTitle}
        keyColumn={keyColumn}
        tableData={tableData}
        tableColumn={tableColumn}
        totalCount={totalCount}
        dataRefresh={getModulesData}
        editLink={settingFormEdit}
        deleteRecords={deleteRecords}
        editRecord={handleInlineEditSave}
        breadCrumbs={breadCrumbs}
        filters={filters}
        submitFilter={submitFilter}
        tableConfig={tableConfig}
        tableControls={tableControls}
        swapContent={
          swapContentType ? (
            <ModulesSwapContentComponent type={swapContentType} />
          ) : null
        }
      />
    </PageWrapperComponent>
  );
}

export default ModulesListTemplateComponent;
